(function ($) {
    if ($('.mo-tabs').length) {
        const iframe1 = document.querySelectorAll('#tab-0 iframe');
        let player1 = {};
        if(iframe1[0]) {
            player1 = new Vimeo.Player(iframe1[0]);
        }
        const iframe2 = document.querySelectorAll('#tab-1 iframe');
        let player2 = {};
        if(iframe2[0]) {
            player2 = new Vimeo.Player(iframe2[0]);
        }
        var currentTab = 0;
        $('.nav-link').on('click', function () {
            var actualTab = $('.nav-link').index(this);
            if(currentTab != actualTab) {
                currentTab = actualTab;
                if(actualTab == 0 && !isEmpty(player2)){
                    player2.pause();     
                } else if(!isEmpty(player1)) {
                    player1.pause();  
                }
            }
        });
    }

    function isEmpty(obj) {
        for(var prop in obj) {
            if(obj.hasOwnProperty(prop))
                return false;
        }
    
        return true;
    }
})(jQuery);
